/**
 * When we don't need locale or inner number comparisons it is much faster to just compare strings directly
 * If you do need inner number comparisons (ie "Test 123" > "Test 20") then you should use numericCollator
 */
export const strCompare = (a: string, b: string) => {
  if (a > b) return 1;
  if (a < b) return -1;
  return 0;
};

export const numericCollator = new Intl.Collator(undefined, { sensitivity: 'case', numeric: true });

/**
 * Default-locale collation, identical to `a.localeCompare(b)` with no arguments, without building a collator per
 * comparison. Use it when an existing `localeCompare` ordering must be preserved.
 */
export const defaultCollator = new Intl.Collator();
